import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { i18nTB } from 'utils/shared/utils';

type TripBuilderClientFlights2Props = {
  label?: string;
  title: string;
  children: ReactNode;
};

const TripBuilderClientFlights2: FC<TripBuilderClientFlights2Props> = ({ label, title, children }) => {
  const { i18n } = useTranslation(undefined, { i18n: i18nTB });

  return (
    <section className="tb2-flights" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
      <div className="tb2-flights-head">
        {!!label && <div className="tb2-flights-label">{label}</div>}
        <h3 className="tb2-flights-title">{title}</h3>
      </div>
      <div className="tb2-flights-body">{children}</div>
    </section>
  );
};

export default TripBuilderClientFlights2;
